import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import CustomPagination from '../../components/CustomPagination'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { useIncentive } from '../../hooks/Features/useIncentive'
import { formatNumber, getUniqueValues } from '../../shared/constants'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'
import { SortIcon, FilterIcon } from '../../components/CustomComponents/CustomFilterIcon'
import moment from 'moment'

function Incentives() {
  const { getAllIncentive, loading, paginate, incentives, getPdfCsvData, downloadLoading, pdfCsvData, downloadKeys } = useIncentive()

  const [searchQuery, setSearchQuery] = useState('')

  const startDate = moment().startOf('quarter')
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())

  const [page, setPage] = React.useState(1)

  const [filterParams, setFilterParams] = useState({ storeName: null, firstName: 1 })

  const noOfPages = paginate.totalPage

  useEffect(() => {
    getAllIncentive({ from, to, ...filterParams, searchQuery, page })
  }, [from, to, filterParams, searchQuery, page])

  useEffect(() => {
    getPdfCsvData(downloadKeys.INCENTIVES, { from, to })
  }, [from, to])

  const handleChange = (event, value) => {
    setPage(value)
  }

  const tableHeading = ['Employee', 'Employee Code', 'store', 'store code']

  let tempTableHeading = []
  incentives && incentives.forEach((item) => item.allSchemeOfStore.forEach((val) => tempTableHeading.push(val.name)))

  let finalTableHeading = [...tableHeading, ...tempTableHeading, 'Total']
  finalTableHeading = finalTableHeading.filter(getUniqueValues)

  return (
    <Layout
      heading="Incentive"
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={pdfCsvData.headings}
      data={pdfCsvData.headingValues}
      filename="incentive"
      downloadLoading={downloadLoading}
    >
      <CustomTable>
        {incentives.length > 0 && (
          <CustomTableHeading
            filterIcons={{
              Employee: (
                <SortIcon
                  onClick={() =>
                    setFilterParams({
                      ...filterParams,
                      storeName: '',
                      firstName: filterParams.firstName === 1 ? -1 : 1,
                    })
                  }
                  value={filterParams.firstName}
                />
              ),
              store: (
                <SortIcon
                  onClick={() =>
                    setFilterParams({
                      ...filterParams,
                      firstName: '',
                      storeName: filterParams.storeName === 1 ? -1 : 1,
                    })
                  }
                  value={filterParams.storeName}
                />
              ),
            }}
            heading={finalTableHeading}
          />
        )}
        <TableBody>
          {!loading &&
            incentives.length > 0 &&
            incentives.map((item, index) => {
              let tempLength = []

              for (let ind = 0; ind < tempTableHeading.filter(getUniqueValues).length - item.allSchemeOfStore.length; ind++) tempLength.push(0)

              return (
                <CustomTableRow key={index}>
                  <TableCell> {item.employeeName} </TableCell>
                  <TableCell> {item.employeeCode} </TableCell>
                  <TableCell> {item.storeName} </TableCell>
                  <TableCell> {item.storeCode} </TableCell>
                  {item.allSchemeOfStore.map((val) => (
                    <TableCell> {formatNumber(val.totalSaleAmount)} </TableCell>
                  ))}
                  {tempLength.map(() => (
                    <TableCell></TableCell>
                  ))}
                  <TableCell>{formatNumber(item.totalSaleAmount)}</TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>

      {!loading && incentives.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}

      {!loading && !incentives.length && <NoDataFound text="No Incentive Found" />}

      {loading && <Loader />}
    </Layout>
  )
}

export default Incentives
